import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SFTY_WORKFLOW } from 'config/flags';

const STORAGE_KEY = 'isSFTYUser';
export const SFTY_STORAGE_KEY = STORAGE_KEY;

// True when the user arrived from SFTY (?isSFTYUser=true). The flag is
// persisted for the browser session so it survives internal SPA navigation,
// where the query param would otherwise be lost.
export const useIsSFTYUser = (): boolean => {
  const location = useLocation();
  const isSFTYUserFromUrl =
    new URLSearchParams(location.search).get(STORAGE_KEY) === 'true';

  useEffect(() => {
    if (isSFTYUserFromUrl) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    }
  }, [isSFTYUserFromUrl]);

  return (
    SFTY_WORKFLOW &&
    (isSFTYUserFromUrl || sessionStorage.getItem(STORAGE_KEY) === 'true')
  );
};
